import { Button, Grid, Typography } from "@material-ui/core";
import { Fragment } from "react";
import { toolbarStyles } from "./toolbarStyles";

type TimeButtonsProps = {
  onChangeType: (type: "hours" | "minutes" | "seconds") => void;
  date: Date;
};

export const TimeButtons = ({ onChangeType, date }: TimeButtonsProps) => {
  const classes = toolbarStyles();
  const formatTime: {
    [key in "hours" | "minutes" | "seconds"]: string;
  } = {
    hours: Intl.DateTimeFormat([], { hour: "2-digit", hour12: true })
      .format(date)
      .slice(0, -2),
    minutes: date.getMinutes().toString().padStart(2, "0"),
    seconds: date.getSeconds().toString().padStart(2, "0"),
  };

  return (
    <Grid item xs={6} className={classes.timeContainer}>
      {(["hours", "minutes", "seconds"] as const).map((component) => (
        <Fragment key={component}>
          <Button
            variant="text"
            className={classes.timeButton}
            onClick={() => onChangeType(component)}
          >
            <Typography variant="h4">{formatTime[component]}</Typography>
          </Button>
          {component !== "seconds" && (
            <Typography variant="h4" style={{ display: "inline-block" }}>
              :
            </Typography>
          )}
        </Fragment>
      ))}
    </Grid>
  );
};
